import { Modal } from 'antd';
import PropTypes from 'prop-types';

const TaskModal = ({ showModal, children, closeModalHandler, action }) => {
  // Initialize the state based on the showModal prop
  return (
    <Modal
      open={showModal}
      onOk={closeModalHandler}
      onCancel={closeModalHandler}
      footer={null}
      closable={false}
      maxHeight={'100vh'}
      width={
        action === 'add_event' ||
        action === 'edit_event' ||
        action === 'reminder_event' ||
        action === 'edit_reminder_event'
          ? 1510
          : action === 'add_task'
            ? 1005
            : 1132
      }
      className={`task-modal-container ${action}`}
    >
      <div className="modal-container">{children}</div>
    </Modal>
  );
};

TaskModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  children: PropTypes.node,
  closeModalHandler: PropTypes.func.isRequired,
  action: PropTypes.string,
};

export default TaskModal;
